import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	selectUserWidgetList: () => client.get(`${BASE_URL}/widget/v1/`).then(res => res && res.data),
	selectWidgetMaster: () => client.get(`${BASE_URL}/widget/v1/widgetMaster`).then(res => res && res.data),
	updateUserWidgets: body => client.post(`${BASE_URL}/widget/v1/update`, body).then(res => res && res.data),
	insertUserWidgets: body => client.post(`${BASE_URL}/widget/v1/insert`, body).then(res => res && res.data)
};
